import request from '@/utils/request'


export function addCollection(data) {
    return request({
        url: `api/serviceCenter/collection/addCollection`,
        method: 'post',
        data,
    })
}

export function upDateCollection(data) {
    return request({
        url: `api/serviceCenter/collection/upDateCollection`,
        method: 'post',
        data,
    })
}

export function CollectionSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/collection/CollectionSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteCollection(data) {
    return request({
        url: `api/serviceCenter/collection/bathDeleteCollection`,
        method: 'post',
        data,
    })
}






